import React, { FC } from "react";
import ReusableAccordian from "../ReusableAccordion";
import SizeLayout from "../SizeLayout";
import PleaseNote from "../PleaseNote";
import { Typography } from "@mui/material";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useHeightSelection from "./useHeightSelection";

const StyledTypography = styled(Typography)({
  fontSize: 20,
  fontWeight: "bold",
  paddingRight: 40,
  width: 250
});

const BifoldComboHeightAccordian: FC = () => {
  const {
    handleHeightChangeDoor,
    handleFractionChangeDoor,
    handleFractionChangeWindow,
    handleHeightChangeWindow,
    heightErrDoor,
    heightErrWindow,
    doorHeight,
    windowHeight,
    doorHeightFraction,
    windowHeightFraction,
  } = useHeightSelection();

  return (
    <ReusableAccordian
      accordionName="height"
      heading="Net Frame Height"
      secondaryHeading=" Select a Height"
      required5={true}
      colOrRow="col"
    >
      <PleaseNote
        intro="Recommended Net Frame Height clearance is as follows:"
        notes={[
          "1/2 inch less than the Rough Opening Height for Raised Sills",
          "1-3/8 inches less than the RO Height for Ultra Guide tracks",
          "1-5/8 inches less than the RO Height for Ultra Guide tracks with a Brio accordion Screen",
        ]}
      />

      <RowLayout>
        <ColLayout style={{ marginRight: 40 }}>
          <RowLayout>
            <StyledTypography>Door Net Height:</StyledTypography>
            <SizeLayout
              size={doorHeight || ""}
              handleChange={handleHeightChangeDoor}
              sizeErr={heightErrDoor}
              name="height"
              fractionValue={doorHeightFraction || ""}
              handleFractionChange={handleFractionChangeDoor}
            />
          </RowLayout>
          <RowLayout>
            <StyledTypography>Window Net Height:</StyledTypography>
            <SizeLayout
              size={windowHeight || ""}
              handleChange={handleHeightChangeWindow}
              sizeErr={heightErrWindow}
              name="height"
              fractionValue={windowHeightFraction || ""}
              handleFractionChange={handleFractionChangeWindow}
            />
          </RowLayout>
        </ColLayout>
      </RowLayout>
    </ReusableAccordian>
  );
};

export default BifoldComboHeightAccordian;
